// extracted by mini-css-extract-plugin
export var container = "_hp-0";
export var dotAnimation = "_hp-2";
export var dotsLoading = "_hp-1";